import { Card, Col, List, Spin } from 'antd'

import { renderFormatMessage } from '../../../../helpers/intl'
import { ListingBase } from '../../../../models/listing'

interface props {
  listings: ListingBase[]
  loading: boolean
  onConnectorType: (listing: ListingBase) => React.ReactNode
  actions: (listing: ListingBase) => React.ReactNode
}

export const ChargerTabListingMobileView: React.FC<props> = ({ listings, loading, onConnectorType, actions }) => {
  return (
    <Col span={24}>
      <Spin spinning={loading}>
        {listings.map((listing) => (
          <Card title={listing.title} key={listing.id} loading={loading}>
            <List
              loading={loading}
              dataSource={[listing]}
              renderItem={(listing) => (
                <>
                  <List.Item actions={[listing.connector.connectorId]}>
                    <List.Item.Meta title={renderFormatMessage('dashboard.connector.connectorId', 'Connector ID')} />
                  </List.Item>
                  <List.Item actions={[onConnectorType(listing)]}>
                    <List.Item.Meta
                      title={renderFormatMessage('dashboard.text.connectorType.heading', 'Connector Type')}
                    />
                  </List.Item>
                  <List.Item actions={[actions(listing)]}>
                    <List.Item.Meta
                      title={renderFormatMessage('dashboard.chargerPage.listing.action.heading', 'Action')}
                    />
                  </List.Item>
                </>
              )}
            />
          </Card>
        ))}
      </Spin>
    </Col>
  )
}
